import { analyticsService, firebaseService } from "./firebase-service";

export class DiagnosticoInicialService {
  async register(model: any) {
    if (!firebaseService.userUid) await firebaseService.signInAnonymouysly();
    const collectionName = "diagnostico-inicial";
    const docRef = firebaseService.getDocRef(collectionName, firebaseService.userUid);
    await firebaseService.saveDoc(docRef, { ...model });
    analyticsService.event("add-diagnostico-inicial", { id: docRef.id });
    firebaseService.signOutAnonymouysly();
    return docRef.id;
  }
}
